import React, { useState } from 'react';

/**
 * Exemplo simples de calculadora de ROI
 * Mostra como o ROI é calculado => ((Revenue - Investment) / Investment) * 100
 */
const ROICalculator = () => {
  const [form, setForm] = useState({ investment: '', revenue: '' });
  const [roi, setRoi] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleCalculate = (e) => {
    e.preventDefault();
    const investment = parseFloat(form.investment) || 0;
    const revenue = parseFloat(form.revenue) || 0;

    if (investment === 0) {
      setRoi('N/A');
      return;
    }
    const calcROI = ((revenue - investment) / investment) * 100;
    setRoi(calcROI.toFixed(2));
  };

  return (
    <div className="roi-calculator">
      <form onSubmit={handleCalculate} className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Investimento (R$)
          </label>
          <input
            type="number"
            name="investment"
            value={form.investment}
            onChange={handleChange}
            className="border w-full p-2 rounded"
            placeholder="0.00"
            min="0"
            step="0.01"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Receita (R$)
          </label>
          <input
            type="number"
            name="revenue"
            value={form.revenue}
            onChange={handleChange}
            className="border w-full p-2 rounded"
            placeholder="0.00"
            min="0"
            step="0.01"
          />
        </div>

        <div className="flex items-end">
          <button
            type="submit"
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 w-full"
          >
            Calcular
          </button>
        </div>
      </form>

      <div className="bg-gray-100 p-3 rounded">
        {roi === null ? (
          <p className="text-gray-500">Preencha os campos para calcular o ROI...</p>
        ) : (
          <p className="text-gray-700">
            ROI: <strong>{roi}%</strong>
          </p>
        )}
      </div>
    </div>
  );
};

export default ROICalculator;
